import { render, staticRenderFns } from "./date.vue?vue&type=template&id=684ab1ca&scoped=true&lang=pug&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ab1ca",
  null
  
)

export default component.exports